import {FuelLevelModel} from '../models/fuel-level.model';
import { Injectable } from "@angular/core";

@Injectable()
export class FuelValues {

    FUEL_VALUES: FuelLevelModel[] = [
        {id: 1, shortDescription: 'N/A', longDescription: 'N/A', level: 100},
        {id: 2, shortDescription: 'Empty', longDescription: 'Fuel Level : Empty', level: 0},
        {id: 3, shortDescription: '1/4 Full', longDescription: 'Fuel Level : 1/4 Full', level: 25},
        {id: 4, shortDescription: '1/2 Full', longDescription: 'Fuel Level : 1/2 Full', level: 50},
        {id: 5, shortDescription: '3/4 Full', longDescription: 'Fuel Level : 3/4 Full', level: 75},
        {id: 6, shortDescription: 'FULL', longDescription: 'Fuel Level : Full', level: 100}
    ];

    // public static FuelLevelDTO NA = new FuelLevelDTO(1,"N/A","",0);
    // public static FuelLevelDTO EMPTY = new FuelLevelDTO(2,"Empty","Fuel Level : Empty",25);
    // public static FuelLevelDTO QUARTERFULL = new FuelLevelDTO(3,"1/4 Full","Fuel Level : 1/4 Full",25);
    // public static FuelLevelDTO HALFFULL = new FuelLevelDTO(4,"1/2 Full","Fuel Level : 1/2 Full",50);
    // public static FuelLevelDTO THREEQUARTERFULL = new FuelLevelDTO(5,"3/4 Full","Fuel Level : 3/4 Full",75);
    // public static FuelLevelDTO FULL = new FuelLevelDTO(6,"FULL","Fuel Level : Full",100);

    // private Integer id;
    // private String shortDescription;
    // private String longDescription;
    // private Integer level;
}
